import React, { useEffect, useState } from 'react';
import { Typography } from '@material-ui/core';
import { getRunningDuration } from 'src/utils';

interface Props {
  createdAt?: string;
  hasLog?: boolean;
  onRenderActions?: () => void;
}

// eslint-disable-next-line no-unused-vars
export const TapTapRunningDuration = ({
  createdAt,
  // eslint-disable-next-line no-unused-vars
  hasLog,
  onRenderActions
}: Props) => {
  const [, setNowTick] = useState(0);

  useEffect(() => {
    const intervalId = window.setInterval(() => {
      setNowTick((current) => current + 1);
    }, 1000);

    return () => window.clearInterval(intervalId);
  }, []);

  if (!createdAt) {
    return null;
  }

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginTop: 20
      }}
    >
      {onRenderActions?.()}
      <Typography
        variant="body2"
        color="textSecondary"
        style={{
          fontWeight: 700,
          textAlign: 'right'
        }}
      >
        Running Duration: {getRunningDuration(createdAt)}
        {/* {!hasLog ? ' (from created date)' : ''} */}
      </Typography>
    </div>
  );
};

export default TapTapRunningDuration;
